import { OutputEmitterRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { getRouteForElement } from "../routes-utils";
import { Router } from "@angular/router";
import { BuyOrderEditFormComponent } from "../../inventory/actions/form/edit/buy-order-form/buy-order-edit-form.component";
import { FinancialMovementEditFormComponent } from "../../invoice/financial-movements/form/edit/edit.component";

export interface GoToEditArgs {
  id: number;
  type: string;
  mode?: "modal" | "route";
  afterClosed?: OutputEmitterRef<void>;
  dialog?: MatDialog;
  router?: Router;
}

export function goToEdit({id, type, mode="modal", afterClosed, dialog, router}: GoToEditArgs) {
  if (mode === "modal") {
    goToEditDialog(id, type, afterClosed, dialog);
  } else {
    goToEditRoute(id, type, router);
  }
}

function goToEditDialog(id: number, type: string, afterClosed?: OutputEmitterRef<void>, dialog?: MatDialog) {
  const dialogParams = getDialogParamsFor(id, type);

  if (!dialogParams) return;

  dialog.open(
    dialogParams.component, 
    {...dialogParams.params, minWidth: "80%"}
  ).afterClosed().subscribe(() => {
    afterClosed?.emit();
  });
}

function goToEditRoute(id: number, type: string, router: Router) {
  const route = getRouteForElement(type, id);
  if (route) {
    router.navigate(route);
  }
}

function getDialogParamsFor(id: number, type: string) {
  const params = mapTypeWithDialogParams(id)[type];
  if (!params) {
    console.error(`No dialog params found for type: ${type}`);
  }
  return params; 
}

const mapTypeWithDialogParams = (id: number) => ({
  'InventoryAction::BuyOrder': {
    component: BuyOrderEditFormComponent,
    params: { data: {id} },
  },
  'FinancialMovement': {
    component: FinancialMovementEditFormComponent,
    params: { data: {id} },
  },
});
